import React, { useRef, useEffect, useState, useCallback, useContext } from 'react'
import CommonService from '../../../../../services/api/common.service'
import TabsTemplate from '../../../../templates/components/TabsTemplate'
import AsyncSelect from 'react-select/async'
import TransactionService from '../../../../../services/api/transaction.service';
import moment from 'moment'
import Utilities from '../../../../../services/commonservice/utilities'
import TransactionsCardList from '../transactions-card/TransactionsCardList'
import ModalBox from '../../../../templates/components/ModalBox'
import AddInvoice from '../../invoices/add-invoice/AddInvoice'
import { debounce } from 'lodash'
import AddPatient from '../../patient/add-patient/AddPatient'
import { ChannelTypeEnum as filters } from '../../../../../common/enum/channel-type.enum'
import { store } from "../../../../../context/StateProvider";
import PaginationTemplate from '../../../../templates/components/PaginationTemplate'
import PracticeLocationSelector from '../../../../templates/components/PracticeLocationSelector';
import SemanticDatepicker from 'react-semantic-ui-datepickers'
const FindAllTransactionsList = (props) => {
    const globalStateAndDispatch = useContext(store);
    const contextState = globalStateAndDispatch.state;
    const [transactions, setTransactions] = useState([])
    const [keyword, setKeyword] = useState()
    const [sortBy, setSortBy] = useState(false)
    const [activeKey, setActiveKey] = useState('patientId')
    const [currentFilter, setCurrentFilter] = useState()
    const [secondFilter, setSecondFilter] = useState()
    const [isLoader, setIsLoader] = useState(false)
    const [collectPayment, setCollectPayment] = useState(false)
    const [showAdd, setShowAdd] = useState(false)
    const [pageCount, setPageCount] = useState()
    const [startRow, setStartRow] = useState(0)
    const [locationId, setLocationId] = useState(contextState.practiceLocationId);
    const [isLocationClearable, setIsLocationClearable] = useState(contextState.providerSelected?.practiceLocationUsers?.length > 0 ? false : true)
    const isFirstRender  = useRef(true);
    const transactionStatusList = [
        { 'statusName': 'All', 'id': '' },
        { 'statusName': 'Created', 'id': 0 },
        { 'statusName': 'Pending', 'id': 1 },
        { 'statusName': 'Authorized', 'id': 2 },
        { 'statusName': 'Posted', 'id': 3 },
        { 'statusName': 'Failed', 'id': 5 },
        { 'statusName': 'Void', 'id': 8 },
        { 'statusName': 'Refunded', 'id': 9 },
        { 'statusName': 'Approved', 'id': 10 },
        { 'statusName': 'Void attempted', 'id': 11 },
        { 'statusName': 'Refund attempted', 'id': 12 },
        { 'statusName': 'Hold', 'id': 13 },
        { 'statusName': 'Denied', 'id': 14 },
        { 'statusName': 'Paid', 'id': 16 },
        { 'statusName': 'Retried', 'id': 17 },
        { 'statusName': "Swipe Canceled", id: 20 },
        { 'statusName': "Partial Approved", id: 21 },
        { 'statusName': "Swipe Initiated", id: 22 },
        { 'statusName': 'Closed', 'id': 30 },
    ];


    const invoiceLoad = (inputText, callBack) => {
        if (inputText?.length < 3) return;
        // setIsLoader(true)
        let reqObj = {
            SortField: 'createdOn',
            Asc: false,
            StartRow: 0,
            PageSize: 10,
            InvoiceNo: inputText
        }
        TransactionService.findTransaction(reqObj)
            .then(res => {
                console.log(res.data.data)
                callBack(res.data.data)
            })
    }
    const reInvoiceLoad = useCallback(debounce(invoiceLoad, 500), [])


    const patientLoad = (inputText, callBack) => {
        if (inputText?.length < 3) return;
        let reqObj = {
            SearchTerm: inputText,
            isActive: true,
            isRegistered: true,
            SortField: 'lastName',
            SortField2: 'firstName',
            Asc: true,
            Asc2: true
        }
        CommonService.patientLookup(reqObj)
            .then(res => {
                if (res && res.data) {
                    callBack(res.data)
                }
            }
            )
            .catch(err => console.log(err))
    }
    const rePatientLoad = useCallback(debounce(patientLoad, 500), [])
    const onPageChange = (data) => {
        setStartRow(CommonService.calculatePageStartRow(data?.selected, 10))
    }

    const transactionLookup = (data) => {
        setIsLoader(true)
        let reqObj = {
            SortField: 'TransactionDate',
            Asc: sortBy,
            StartRow: startRow || 0,
            PageSize: 10,
            PracticeLocationIds: locationId || null
        }
        if (activeKey == 'patientId' && keyword) {
            reqObj.PatientIds = keyword
        }
        if (activeKey == 'transactionDate' && keyword) {
            reqObj.StartDate = new Date(moment(keyword).startOf('d')).toISOString()
            reqObj.EndDate = new Date(moment(keyword).add(1, "d").startOf('d')).toISOString()
        }
        if (activeKey == 'invoiceNumber' && keyword) {
            reqObj.InvoiceNo = keyword
        }
        if (secondFilter) {
            reqObj.Statuses = secondFilter
        }
        if (currentFilter) {
            reqObj.ChannelType = currentFilter
        }
        TransactionService.findTransaction(reqObj)
            .then(res => {
                if (res?.data?.data) {
                    setPageCount(Math.ceil(res.data.totalRowCount / 10))
                    setTransactions(res.data.data)
                }
                return setIsLoader(false)
            })
    }

    useEffect(() => {
        if (startRow !== 0) {
            setStartRow(0)
        } else {
            transactionLookup()
        }
    }, [keyword, currentFilter,secondFilter, sortBy, locationId])
    useEffect(() => {
        // Skip initial execution
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        transactionLookup()
    }, [startRow])
    const onLocationChanged = (newLocationId) => {
        setLocationId(newLocationId)
    }
    return (
        <div className=''>
            <div title="Search" className='row d-flex align-items-end' id="transactionSearchBar">
                <div className='col-md-4 col-12'>
                    <TabsTemplate style="pills" activeKey={activeKey} onSelect={k => { setActiveKey(k); setKeyword() }}>
                        <div title="Patient" eventKey="patientId">
                            <AsyncSelect
                                classNamePrefix="react-select"
                                className="react-select-container"
                                name="patientId"
                                loadOptions={rePatientLoad}
                                placeholder="Search Patient"
                                onChange={e => {
                                    if (e?.id) {
                                        setKeyword(e.id)
                                    }
                                    else {
                                        setKeyword()
                                    }
                                }}
                                isClearable={true}
                                formatOptionLabel={(option, { context }) => {
                                    if (context === "menu") {
                                        // Dropdown View
                                        return (
                                            <div className="d-flex row">
                                                <span className="col">{option.firstName} {option.lastName}</span>
                                                <span className="col text-start">
                                                    <i className="icon birthday cake" /> {moment.utc(option.dob).format("M/D/YYYY")}
                                                </span>
                                                <span className="col text-end">
                                                    {option.mobile || option.patientPhone ? (
                                                        <>
                                                            <i className="icon phone" />
                                                            {Utilities.toPhoneNumber(option.mobile || option.patientPhone)}
                                                        </>
                                                    ) : null}
                                                </span>
                                            </div>
                                        );
                                    } else {
                                        // Selected View
                                        return (
                                            <div style={{
                                                display: 'flex'
                                            }}>
                                                <span style={{ marginRight: '8px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                    {option.firstName} {option.lastName}
                                                </span>
                                                <i className='icon birthday cake' style={{ marginRight: '4px' }} />
                                                <span style={{ marginRight: '8px' }}>
                                                    {moment.utc(option.dob).format("M/D/YYYY")}
                                                </span>
                                                {(option.mobile || option.patientPhone) && (
                                                    <>
                                                        <i className='icon phone' style={{ marginRight: '4px' }} />
                                                        <span>
                                                            {Utilities.toPhoneNumber(option.mobile || option.patientPhone)}
                                                        </span></>
                                                )}
                                            </div>
                                        );
                                    }
                                }}
                                // getOptionLabel={(option) => {
                                //     return (
                                //         <div className="d-flex row">
                                //             <span className="col">{option.firstName} {option.lastName}</span>
                                //             <span className='col text-start'><i className='icon birthday cake' />{moment.utc(option.dob).format("M/D/YYYY").toString()}</span>
                                //             <span className='col text-end'>
                                //                 {option.mobile && option.mobile != '' || option.patientPhone && option.patientPhone != '' ?
                                //                     <>
                                //                         <i className='icon phone' />
                                //                         {option.mobile && option.mobile != '' ? Utilities.toPhoneNumber(option.mobile) : option.patientPhone && option.patientPhone != '' ? Utilities.toPhoneNumber(option.patientPhone) : null}
                                //                     </> : null}
                                //             </span>
                                //         </div>
                                //     )
                                // }}
                                getOptionValue={(option) => option.id}
                                noOptionsMessage={(e) => {
                                    if (!contextState.permissions.patientModifyPatients) {
                                        return null;
                                    }
                                    else {
                                        return <button className='btn btn-primary form-control' onClick={e => { e.preventDefault(); setShowAdd(true) }}>Add Patient</button>
                                    }
                                }}
                            />
                        </div>
                        <div title="Invoice Number" eventKey="invoiceNumber">
                            <AsyncSelect
                                classNamePrefix="react-select"
                                className="react-select-container"
                                name="invoiceNumber"
                                loadOptions={reInvoiceLoad}
                                loadingMessage={(e) => {
                                    if (e && e.inputValue?.length < 3) {
                                        return "Please type at least 3 characters to start searching..."
                                    } else {
                                        return "Loading..."
                                    }
                                }}
                                placeholder="Search Invoice"
                                onChange={e => {
                                    if (e?.id) {
                                        setKeyword(e.invoiceNumber)
                                    }
                                    else {
                                        setKeyword()
                                    }
                                }}
                                isClearable={true}
                                getOptionLabel={(option) => {
                                    return (
                                        // option.id + '  | ' + 
                                        option.firstName + ' ' + option.lastName + ' | ' + option.invoiceNumber + ' | ' + Utilities.toDollar(option.tenderInfo?.totalAmount)
                                    )
                                }
                                }
                                getOptionValue={(option) => option.id}
                            />
                        </div>

                        <div title="Transaction Date" eventKey="transactionDate">
                            <div className="custom-datepicker">
                                <SemanticDatepicker
                                    allowOnlyNumbers={true}
                                    clearIcon={'delete calendar'}
                                    clearOnSameDateClick={true}
                                    clearable={true}
                                    format={'MM-DD-YYYY'}
                                    icon={'calendar outline'}
                                    onChange={(e, data) => {
                                        //console.log(data)
                                        //e.preventDefault()
                                        setKeyword(data.value)
                                    }}
                                />
                            </div>
                        </div>
                    </TabsTemplate>
                </div>
                <div className='col-md-8 col-12'>
                    <div className='d-flex row my-3'>
                        <div className="col-md-4 col-12">
                            <div className="field">
                                <label>Practice Location: </label>
                                <PracticeLocationSelector isClearable={isLocationClearable} dontResetState={true} onSelected={onLocationChanged} />
                            </div>
                        </div>
                        <div className='col-md-2 col-12'>
                            <div className="field">
                                <label>Sort by: </label>
                                <select className='form-select' onChange={e => { setSortBy(e.target.value) }}>
                                    <option value={false} selected>Date: Desc</option>
                                    <option value={true}>Date: Asc</option>
                                </select>
                            </div>
                        </div>
                        <div className='col-md-3 col-12'>
                            <div className="field">
                                <label>Transaction Status: </label>
                                <select className='form-select' onChange={e => { e.preventDefault(); setSecondFilter(e.target.value) }}>
                                    {transactionStatusList.map((obj, i) => {
                                        return (
                                            <option value={obj.id}>
                                                {obj.statusName}
                                                {/* (
                                            {Array.isArray(transactions) && transactions.filter((tc) => {
                                                if (obj.id == "" || obj.id == null) {
                                                    return tc
                                                } else if (tc.transactionStatus == parseInt(obj.id)) {
                                                    return tc
                                                }
                                            }).filter((transaction) => {
                                                if (keyword == "" || keyword == null || !keyword) {
                                                    return transaction
                                                } else if (transaction[activeKey]==keyword|| moment(transaction[activeKey]).format("YYYY-MM-DD")==keyword) {
                                                    return transaction
                                                }

                                            }).length}
                                            ) */}
                                            </option>
                                        )
                                    })
                                    }
                                </select>
                            </div>
                        </div>
                        <div className='col-md-3 col-12'>
                            <div className="field">
                                <label>Payment Type: </label>
                                <select className='form-select' onChange={e => { e.preventDefault(); setCurrentFilter(e.target.value) }}>
                                    {filters.map((obj, i) => {
                                        return (
                                            <option value={obj.value}>
                                                {obj.title}
                                                {/* (
                                            {Array.isArray(transactions) && transactions.filter((tc) => {
                                                if (obj.value == "" || obj.value == null) {
                                                    return tc
                                                } else if (tc.tenderInfo.channelType === obj.value) {
                                                    return tc
                                                }
                                            }).filter((transaction) => {
                                                if (keyword == "" || keyword == null || !keyword) {
                                                    return transaction
                                                } else if (transaction[activeKey]==keyword || moment(transaction[activeKey]).format("YYYY-MM-DD")==keyword) {
                                                    return transaction
                                                }

                                            }).length}
                                            ) */}
                                            </option>
                                        )
                                    })
                                    }
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className='col-auto mb-3'>
                    <button className='btn btn-primary' onClick={e => { e.preventDefault(); setCollectPayment(true) }} title="Create Invoice"><i className='icon plus' /></button>
                </div> */}
            </div>
            <div className='row-fluid' title="Invoices">
                {isLoader ? <div className="ui warning message mt-3 segment p-3 shadow-sm">
                    <span>Please be patient while data loads...</span>
                </div> :
                    <>
                    {Array.isArray(transactions) && transactions
                        // .filter((tc) => {
                        //     if (currentFilter === "" || currentFilter === null || !currentFilter) {
                        //         return tc
                        //     } else if (tc.tenderInfo.channelType === parseInt(currentFilter)) {
                        //         return tc

                        //     }
                        // }).filter((tc) => {
                        //     if (secondFilter === "" || secondFilter === null || !secondFilter) {
                        //         return tc
                        //     } else if (tc.transactionStatus === parseInt(secondFilter)) {
                        //         return tc

                        //     }
                        // })
                        // .sort((a, b) => sortBy === 'Desc' ? b.createdOn.localeCompare(a.createdOn) : a.createdOn.localeCompare(b.createdOn))
                        .filter((transaction) => {
                            if (keyword === "" || keyword === null || !keyword) {
                                return transaction
                            } else {
                                if (transaction[activeKey] == keyword || moment(transaction[activeKey]).format("YYYY-MM-DD") == keyword)
                                    return transaction
                            }
                        }).map((tc, i) => {
                            // console.log(tc)
                            return (
                                <TransactionsCardList transaction={tc} refresh={() => { transactionLookup() }} />
                            )
                        })}
                    {Array.isArray(transactions) && transactions.length > 0 &&
                        <PaginationTemplate onPageChange={onPageChange} pageCount={pageCount} forcePage={Math.floor(startRow / 10)}/>
                    }
                </>}
            </div>
            <ModalBox open={showAdd} onClose={() => { setShowAdd(false) }}>
                <AddPatient onClose={() => { setShowAdd(false) }} />
            </ModalBox>
            <ModalBox open={collectPayment} onClose={() => { setCollectPayment(false) }} title="Collect Payment" size="fullscreen">
                <AddInvoice onClose={() => { transactionLookup(); return setCollectPayment(false) }} />
            </ModalBox>
        </div>
    )
}

export default FindAllTransactionsList